import * as Api from '@/api'

const POST_SMS = '/sms/lts/:lt'

export default {
  sendSms (lt) {
    return Api.http(true).post(POST_SMS.replace(':lt', lt, {}))
  }
}
